import { css } from 'lit';

export default css`
  :host {
    border-block-end: var(--sl-color-border-plain) solid var(--sl-size-borderWidth-default);
    inline-size: 100%;
    margin-block-end: var(--sl-size-075);
    margin-inline: 0;
    padding-block-end: var(--sl-size-100);
  }

  [part='container'] {
    margin-inline: var(--sl-size-100);
  }

  sl-icon {
    visibility: visible;
  }
`;
